import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  console.error('Supabase credentials not configured');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

/**
 * Save contact form submission to Supabase
 */
export const saveContactSubmission = async (formData) => {
  try {
    const { data, error } = await supabase
      .from('contact_submissions')
      .insert([
        {
          org_name: formData.orgName,
          name: formData.name,
          phone: formData.number,
          email: formData.email,
          services: formData.services,
          message: formData.message,
          submitted_at: new Date().toISOString(),
        },
      ])
      .select();

    if (error) {
      console.error('Error saving submission:', error);
      throw error;
    }

    console.log('✅ Submission saved to Supabase:', data);
    return data;
  } catch (error) {
    console.error('Error submitting form:', error);
    throw error;
  }
};

/**
 * Fetch all contact submissions from Supabase
 */
export const fetchContactSubmissions = async () => {
  try {
    const { data, error } = await supabase
      .from('contact_submissions')
      .select('*')
      .order('submitted_at', { ascending: false });

    if (error) {
      console.error('Error fetching submissions:', error);
      throw error;
    }

    console.log('✅ Submissions fetched:', data);
    return data || [];
  } catch (error) {
    console.error('Error fetching submissions:', error);
    throw error;
  }
};

/**
 * Delete a submission by ID
 */
export const deleteSubmission = async (id) => {
  try {
    const { error } = await supabase
      .from('contact_submissions')
      .delete()
      .eq('id', id);

    if (error) {
      throw error;
    }

    console.log('✅ Submission deleted');
    return true;
  } catch (error) {
    console.error('Error deleting submission:', error);
    throw error;
  }
};
